document.addEventListener('DOMContentLoaded', function () {
  const socialIcons = document.querySelector('.header__row-segment-desktop--logo-left .social-icons');
  const announcementBar = document.querySelector('.announcement-bar');

  if (socialIcons && announcementBar) {
    announcementBar.appendChild(socialIcons);
  }

  // ลบ complete-the-look ที่ไม่มีรูป
  document.querySelectorAll('.complete-the-look').forEach(function (section) {
    const mainImage = section.querySelector('.complete-the-look__image');
    const productImage = section.querySelector('.product-card-mini__image');

    const mainIsPlaceholder = !mainImage || mainImage.classList.contains('placeholder-image');
    const productIsPlaceholder = !productImage || productImage.classList.contains('placeholder-image');

    if (mainIsPlaceholder && productIsPlaceholder) {
      section.remove();
    }
  });

  // ลบ slideshow slides ที่ไม่มีรูป
  document.querySelectorAll('.slideshow-slide').forEach(slide => {
    if (!slide.querySelector('img.image__img')) {
      slide.remove();
    }
  });

  // ลบ hero split items ที่ไม่มีรูป
  document.querySelectorAll('.image-hero-split-item').forEach(item => {
  const hasRealImage = item.querySelector('img.image__img');
  if (!hasRealImage) {
    item.remove();
  }
});

});